import React, { useState, useEffect } from 'react'
import { Table, IconButton, Icon, Panel, ButtonGroup } from 'rsuite'
import { useHistory } from 'react-router-dom'

export default function ProjectInfoDocTable({ schema, loading, onDownload, onPreview, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  const history = useHistory()

  const [dataLists, setDataLists] = useState([])

  useEffect(() => {
    setDataLists(schema?.data || [])
  }, [schema])

  // console.log('tableData ', tableData)

  return (
    <>
      {dataLists?.map((item, index) => {
        return (
          <>
            <Panel bordered header={item.documentHeader} collapsible defaultExpanded>
              <div>
                <Table
                  wordWrap
                  // height={350}
                  // autoHeight={tableData.length < 10}
                  minHeight={item.values.length < 5}
                  autoHeight
                  loading={loading}
                  data={item.values}
                  style={{ marginTop: 10 }}
                >
                  <Column width={90} align="center">
                    <HeaderCell>ลำดับ</HeaderCell>
                    <Cell>
                      {(_, index) => {
                        return index + 1
                      }}
                    </Cell>
                  </Column>

                  <Column minWidth={250} width={250} flexGrow>
                    <HeaderCell>ชื่อเอกสาร </HeaderCell>
                    <Cell dataKey="documentName" />
                  </Column>
                  <Column width={120} align="center" fixed="right">
                    <HeaderCell></HeaderCell>
                    <Cell>
                      {(rowData) => {
                        // console.log('file ', rowData)
                        
                        return (
                          <>
                            <ButtonGroup>
                              <IconButton
                                appearance="ghost"
                                className="rs-btn-ghost-df"
                                size="sm"
                                icon={<Icon icon="eye" className="bt-gost-icon-none-radius" />}
                                onClick={(e) => {
                                  onPreview(rowData)
                                  // sessionSetItemStr('isViewOnly', 'isViewOnly')
                                }}
                                disabled={!rowData.filePath} //เช็คกรณีที่ pathFile = null
                              ></IconButton>

                              <IconButton
                                appearance="ghost"
                                className="rs-btn-ghost-df"
                                size="sm"
                                //disabled={!rowData.pathFile}
                                icon={
                                  <Icon icon="download" className="bt-gost-icon-none-radius" />
                                }
                                onClick={() => onDownload(rowData)}
                                disabled={!rowData.filePath} //เช็คกรณีที่ pathFile = null
                              ></IconButton>
                            </ButtonGroup>
                          </>
                        )
                      }}
                    </Cell>
                  </Column>
                </Table>
              </div>
            </Panel>
            <br />
          </>
        )
      })}
    </>
  )
}
